var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 62,
    viewBox: "0 0 180 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.0417 26.3304H60.3549V30.8578H65.8178C66.7534 30.8578 67.5603 31.5867 67.5603 32.5223C67.5603 33.4578 66.7534 34.1613 65.8178 34.1613H60.3549V39.3378C60.3549 40.404 59.4972 41.3414 58.4293 41.3414C57.3614 41.3414 56.4512 40.4058 56.4512 39.3378V25.0812C56.4512 23.8319 57.3614 22.9217 58.6106 22.9217H67.0399C67.9755 22.9217 68.7569 23.676 68.7569 24.6116C68.7569 25.5471 67.9773 26.3286 67.0399 26.3286L67.0417 26.3304Z",
    fill: "url(#paint0_linear_2009_4068)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6797 29.4V39.4158C82.6797 40.4566 81.7695 41.2888 80.7541 41.2888C79.7388 41.2888 78.8558 40.4566 78.8558 39.4412C78.5439 40.1701 77.2947 41.3142 75.2386 41.3142C72.3756 41.3142 68.9688 39.1021 68.9688 34.368C68.9688 29.6339 72.4028 27.4473 75.2386 27.4473C77.0336 27.4473 78.4134 28.4355 78.8558 29.5016V29.3982C78.8558 28.3829 79.7134 27.5253 80.7541 27.5253C81.7949 27.5253 82.6797 28.3829 82.6797 29.3982V29.4ZM79.0117 34.3699C79.0117 31.6375 77.2421 30.7019 75.9421 30.7019C74.3556 30.7019 72.7673 31.9511 72.7673 34.3699C72.7673 36.7886 74.3538 38.065 75.9421 38.065C77.2421 38.065 79.0117 37.1276 79.0117 34.3699Z",
    fill: "url(#paint1_linear_2009_4068)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8629 33.7969V39.3904C97.8629 40.4312 97.0053 41.2634 95.9646 41.2634C94.9238 41.2634 94.0644 40.4312 94.0644 39.3904V33.7969C94.0644 31.6375 92.9983 30.7019 91.5677 30.7019C89.3303 30.7019 88.7048 32.8867 88.654 33.3817V39.3922C88.654 40.433 87.7964 41.2652 86.7556 41.2652C85.7149 41.2652 84.8555 40.433 84.8555 39.3922V29.4544C84.8555 28.3883 85.7149 27.5289 86.7556 27.5289C87.7964 27.5289 88.654 28.3865 88.654 29.4544V30.4952C88.7573 29.5324 90.2405 27.4781 92.9983 27.4781C95.756 27.4781 97.8629 29.2731 97.8629 33.8005V33.7969Z",
    fill: "url(#paint2_linear_2009_4068)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.367 24.5608C111.94 25.2117 112.224 25.7049 112.224 26.3032C112.224 27.1608 111.573 27.8371 110.611 27.8371C110.012 27.8371 109.439 27.5252 109.077 27.1082C108.4 26.4319 107.855 26.1201 106.892 26.1201C105.461 26.1201 104.707 26.9269 104.707 27.9151C104.707 28.5914 105.044 29.3203 106.527 29.9186L107.385 30.2304C111.651 31.8441 113.187 33.4053 113.187 35.824C113.187 39.5192 109.519 41.3142 106.5 41.3142C104.524 41.3142 102.441 40.5599 101.088 39.0767C100.802 38.7395 100.256 38.036 100.256 37.1512C100.256 36.3443 100.776 35.5121 101.842 35.5121C102.7 35.5121 103.273 36.0579 103.69 36.6036C104.6 37.619 105.615 37.9055 106.473 37.9055C107.617 37.9055 109.18 37.4631 109.18 35.824C109.18 34.6545 108.451 34.0562 106.473 33.2747L105.538 32.9103C102.832 31.8695 100.776 30.5949 100.776 27.8625C100.776 24.6877 103.431 22.7368 106.734 22.7368C108.972 22.7368 110.273 23.5164 111.365 24.5571L111.367 24.5608Z",
    fill: "url(#paint3_linear_2009_4068)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.584 33.7715C127.584 35.28 126.778 35.8004 125.217 35.8004L118.087 35.6971C118.425 37.309 119.701 38.1938 121.496 38.1938C122.355 38.1938 122.615 38.0632 123.369 37.8039C123.889 37.5954 124.279 37.3615 124.774 37.3615C125.554 37.3615 126.049 37.9345 126.049 38.6615C126.049 39.1293 125.867 39.6497 125.139 40.2227C124.228 40.821 122.979 41.2634 121.34 41.2634C117.828 41.2634 114.133 39.1565 114.133 34.4206C114.133 29.6847 118.062 27.4491 121.028 27.4491C123.994 27.4491 127.584 29.8171 127.584 33.7715ZM118.087 33.1478H123.837C123.577 31.4308 122.379 30.7545 121.026 30.7545C119.674 30.7545 118.321 31.4308 118.085 33.1478H118.087Z",
    fill: "url(#paint4_linear_2009_4068)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.858 33.7715C141.858 35.28 141.051 35.8004 139.49 35.8004L132.361 35.6971C132.698 37.309 133.974 38.1938 135.769 38.1938C136.629 38.1938 136.888 38.0632 137.642 37.8039C138.163 37.5954 138.553 37.3615 139.048 37.3615C139.827 37.3615 140.322 37.9345 140.322 38.6615C140.322 39.1293 140.141 39.6497 139.412 40.2227C138.502 40.821 137.253 41.2634 135.613 41.2634C132.101 41.2634 128.406 39.1565 128.406 34.4206C128.406 29.6847 132.335 27.4491 135.302 27.4491C138.268 27.4491 141.858 29.8171 141.858 33.7715ZM132.361 33.1478H138.11C137.851 31.4308 136.652 30.7545 135.3 30.7545C133.947 30.7545 132.595 31.4308 132.359 33.1478H132.361Z",
    fill: "url(#paint5_linear_2009_4068)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.671 39.5989C155.671 40.4837 154.942 41.2634 154.006 41.2634C153.539 41.2634 153.096 41.0549 152.835 40.743L148.464 35.8004L147.086 37.0751V39.3904C147.086 40.4312 146.228 41.2634 145.187 41.2634C144.147 41.2634 143.287 40.4312 143.287 39.3904V24.4556C143.287 23.4149 144.147 22.5573 145.187 22.5573C146.228 22.5573 147.086 23.4149 147.086 24.4556V32.6256L151.794 28.0728C152.106 27.761 152.601 27.5271 153.069 27.5271C154.032 27.5271 154.786 28.3339 154.786 29.2441C154.786 29.7391 154.63 30.1543 154.318 30.4662L150.857 33.641L155.201 38.4802C155.435 38.7141 155.669 39.1311 155.669 39.5989H155.671Z",
    fill: "url(#paint6_linear_2009_4068)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M169.122 33.7715C169.122 35.28 168.315 35.8004 166.754 35.8004L159.626 35.6971C159.964 37.309 161.238 38.1938 163.035 38.1938C163.893 38.1938 164.154 38.0632 164.908 37.8039C165.429 37.5954 165.818 37.3615 166.313 37.3615C167.093 37.3615 167.588 37.9345 167.588 38.6615C167.588 39.1293 167.407 39.6497 166.678 40.2227C165.768 40.821 164.518 41.2634 162.879 41.2634C159.367 41.2634 155.674 39.1565 155.674 34.4206C155.674 29.6847 159.603 27.4491 162.567 27.4491C165.532 27.4491 169.124 29.8171 169.124 33.7715H169.122ZM159.626 33.1478H165.376C165.117 31.4308 163.92 30.7545 162.566 30.7545C161.211 30.7545 159.86 31.4308 159.626 33.1478Z",
    fill: "url(#paint7_linear_2009_4068)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.999 29.2187C179.999 30.2595 179.193 30.9884 177.581 30.9884C175.63 30.9884 174.433 32.4715 174.355 33.3817V39.3922C174.355 40.4058 173.498 41.2652 172.457 41.2652C171.416 41.2652 170.557 40.4076 170.557 39.3922V29.4544C170.557 28.3883 171.414 27.5289 172.457 27.5289C173.499 27.5289 174.355 28.3865 174.355 29.4544V30.4952C174.459 29.5324 176.047 27.4781 178.232 27.4781C179.401 27.4781 179.999 28.285 179.999 29.2205V29.2187Z",
    fill: "url(#paint8_linear_2009_4068)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5363 43.9396C20.9089 44.3765 20.0749 44.3783 19.4439 43.9468C18.8238 43.5044 18.5537 42.7157 18.7676 41.985L20.8672 35.0461L15.1305 30.6964C14.5176 30.2322 14.2583 29.4345 14.4814 28.6965C14.7134 27.9785 15.3789 27.4799 16.1331 27.4581L23.382 27.3113L25.7446 20.5102C25.9966 19.7868 26.6693 19.2954 27.4344 19.2755H27.4471C28.2014 19.2755 28.8777 19.7505 29.1315 20.4612L31.5122 27.3113L38.7103 27.4581C39.4845 27.4745 40.1644 27.9713 40.4147 28.7038C40.6467 29.4272 40.3947 30.2195 39.7873 30.6765L34.0252 35.0443L36.1103 41.936C36.3333 42.6704 36.0758 43.4663 35.4648 43.9323C34.8483 44.382 34.0143 44.3928 33.3869 43.9577L27.4471 39.8237L21.5363 43.9359V43.9396ZM32.7614 42.9786C32.7614 42.9786 32.765 42.9913 32.7668 42.9985L32.7614 42.9786ZM19.5146 41.0748C19.5146 41.0748 19.5001 41.0839 19.4929 41.0893L19.5146 41.0748ZM22.082 31.5685L24.6875 33.543C24.8199 33.6427 24.8779 33.815 24.8326 33.9746L24.5696 34.9156L23.8933 37.1475C23.7827 37.5156 24.1961 37.8166 24.5116 37.5972L26.4644 36.2392L27.206 35.7532C27.3383 35.6662 27.5087 35.6644 27.6429 35.7496L28.4661 36.2664L30.3771 37.5954C30.6926 37.8148 31.106 37.5138 30.9954 37.1457L30.0489 34.0163C30 33.8567 30.0544 33.6845 30.1849 33.5811L30.9519 32.9755L32.8085 31.5685C33.115 31.3364 32.9554 30.8487 32.5728 30.8415L29.2983 30.7744C29.1315 30.7707 28.9846 30.6656 28.9266 30.5096L28.5894 29.5886L27.826 27.3947C27.7009 27.0321 27.1878 27.0321 27.0609 27.3947L25.9911 30.4734C25.9368 30.6293 25.7935 30.7363 25.6285 30.7454L24.6621 30.7943L22.3159 30.8433C21.9315 30.8505 21.7738 31.3383 22.0802 31.5703L22.082 31.5685ZM29.0699 21.6235L29.0662 21.6362C29.0662 21.6362 29.0699 21.6271 29.0699 21.6235Z",
    fill: "url(#paint9_linear_2009_4068)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3449 8.13011C51.7696 8.13011 50.9645 14.1515 50.8975 16.0263C50.892 16.1115 50.892 16.1877 50.892 16.2584C50.892 16.1913 50.8866 16.1115 50.8866 16.0263C50.8159 14.1497 50.0108 8.13011 42.4355 8.13011C50.0108 8.13011 50.8159 2.10868 50.8866 0.232082C50.8866 0.146864 50.892 0.0670861 50.892 0C50.892 0.0707123 50.892 0.146864 50.8975 0.232082C50.9645 2.10868 51.7696 8.13011 59.3449 8.13011Z",
    fill: "url(#paint10_linear_2009_4068)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75564 54.637C4.83201 54.637 4.41499 57.7556 4.38054 58.7275C4.37873 58.771 4.37873 58.8109 4.37873 58.8471C4.37873 58.8127 4.37691 58.771 4.37691 58.7275C4.34065 57.7556 3.92363 54.637 0 54.637C3.92363 54.637 4.34065 51.5184 4.37691 50.5466C4.37691 50.5031 4.37873 50.4614 4.37873 50.4269C4.37873 50.4632 4.37873 50.5031 4.38054 50.5466C4.41499 51.5184 4.83201 54.637 8.75564 54.637Z",
    fill: "url(#paint11_linear_2009_4068)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3464 61.0356C45.8986 61.0356 45.4489 60.8652 45.1062 60.5225L36.2944 51.7107C33.5366 52.9835 30.5051 53.6525 27.4481 53.6525C15.8205 53.6525 6.36133 44.1934 6.36133 32.5657C6.36133 20.9381 15.8205 11.4771 27.4481 11.4771C39.0758 11.4771 48.5349 20.9363 48.5349 32.5639C48.5349 37.2799 47.0119 41.7402 44.1326 45.4608C43.5415 46.2259 42.4391 46.3673 41.674 45.7744C40.9088 45.1815 40.7674 44.081 41.3603 43.3158C43.7609 40.2154 45.0301 36.4966 45.0301 32.5657C45.0301 22.8709 37.143 14.9856 27.4481 14.9856C17.7533 14.9856 9.86612 22.8709 9.86612 32.5639C9.86612 42.257 17.7533 50.1459 27.4463 50.1459C30.3654 50.1459 33.2556 49.417 35.8049 48.0354L36.9544 47.4117L47.5848 58.0421C48.2702 58.7257 48.2702 59.8371 47.5848 60.5207C47.2421 60.8634 46.7943 61.0338 46.3446 61.0338L46.3464 61.0356Z",
    fill: "url(#paint12_linear_2009_4068)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2009_4068",
    x1: 186.529,
    y1: 49.7471,
    x2: 54.2972,
    y2: 30.9321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2009_4068",
    x1: 186.511,
    y1: 49.883,
    x2: 54.2805,
    y2: 31.0663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2009_4068",
    x1: 186.759,
    y1: 48.137,
    x2: 54.5289,
    y2: 29.3221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2009_4068",
    x1: 182.371,
    y1: 42.8046,
    x2: 50.1407,
    y2: 23.9878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2009_4068",
    x1: 182.334,
    y1: 43.0729,
    x2: 50.1037,
    y2: 24.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2009_4068",
    x1: 182.617,
    y1: 41.0821,
    x2: 50.387,
    y2: 22.2672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2009_4068",
    x1: 183.153,
    y1: 37.3144,
    x2: 50.9222,
    y2: 18.4976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2009_4068",
    x1: 183.157,
    y1: 37.2799,
    x2: 50.9271,
    y2: 18.4632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2009_4068",
    x1: 183.41,
    y1: 35.5158,
    x2: 51.1797,
    y2: 16.699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2009_4068",
    x1: 14.3871,
    y1: 46.7771,
    x2: 41.2378,
    y2: 19.9264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2009_4068",
    x1: 4.27082,
    y1: 56.8509,
    x2: 53.5301,
    y2: 5.37051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2009_4068",
    x1: 3.22013,
    y1: 55.8446,
    x2: 52.4812,
    y2: 4.3642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2009_4068",
    x1: 18.3842,
    y1: 50.7714,
    x2: 45.235,
    y2: 23.9207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F59A6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF15E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#AF46FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6094E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoColor);
export default __webpack_public_path__ + "static/media/logo-color.9f00b7d016adb5081eb3ceb02a5735c3.svg";
export { ForwardRef as ReactComponent };